import { makeStyles } from '@material-ui/core'

const styles = makeStyles(() => ({
  description: {
    whiteSpace: 'pre-line',
    wordBreak: 'break-word',
  },
}))

export default styles
